import { Page } from '@medflex/shared-types';

export const getPageFromOffset = ({ offset, limit }: Page): number => offset / limit + 1;
export const getOffsetFromPage = (page: number, { limit }: Page): number => (page - 1) * limit;
